import { readTabUserData } from "../../../utils/tabAuthStorage";

let optimisticSeq = 0;

export function isOptimisticTeamMessageId(id) {
  return typeof id === "string" && id.startsWith("temp-");
}

export function createOptimisticTempId() {
  optimisticSeq += 1;
  return `temp-${Date.now()}-${optimisticSeq}`;
}

export function getTeamCurrentUser() {
  try {
    const userData = readTabUserData() || {};
    return {
      currentUserId: userData?.id ?? null,
      authorName: String(userData?.nome || userData?.name || "").trim() || "Você",
    };
  } catch {
    return { currentUserId: null, authorName: "Você" };
  }
}

function attachmentFromFile(file) {
  const type = String(file?.type || "");
  const localUrl = URL.createObjectURL(file);
  const content = file?.name || " ";

  if (type.startsWith("image/")) {
    return {
      messageType: "image",
      content,
      imageUrl: localUrl,
      _localBlobUrl: localUrl,
    };
  }
  if (type.startsWith("video/")) {
    return {
      messageType: "video",
      content,
      videoUrl: localUrl,
      _localBlobUrl: localUrl,
    };
  }
  if (type.startsWith("audio/")) {
    return {
      messageType: "audio",
      content,
      audioUrl: localUrl,
      _localBlobUrl: localUrl,
    };
  }
  return {
    messageType: "file",
    content,
    fileUrl: localUrl,
    fileName: file?.name || "arquivo",
    _localBlobUrl: localUrl,
  };
}

export function stripOptimisticSendMarkers(payload = {}) {
  const { _file, _audioURL, ...rest } = payload;
  return rest;
}

export function buildOptimisticTeamMessage(payload, { tempId, spaceId, currentUserId, authorName }) {
  const now = new Date().toISOString();
  const base = {
    id: tempId,
    spaceId,
    authorType: "user",
    authorId: currentUserId,
    authorName,
    createdAt: now,
    sendStatus: "sending",
    _optimistic: true,
    receipts: [],
    reactions: [],
    replyToId: payload.replyToId ?? null,
    replyPreview: payload.replyPreview ?? null,
    leadId: payload.leadId ?? null,
    mentions: payload.mentions ?? null,
    metadata: payload.metadata ?? null,
  };

  if (payload._file) {
    return { ...base, ...attachmentFromFile(payload._file) };
  }

  if (payload._audioURL) {
    return {
      ...base,
      messageType: "audio",
      content: " ",
      audioUrl: payload._audioURL,
    };
  }

  return {
    ...base,
    messageType: payload.messageType || "text",
    content: payload.content || "",
    imageUrl: payload.imageUrl ?? null,
    videoUrl: payload.videoUrl ?? null,
    audioUrl: payload.audioUrl ?? null,
    fileUrl: payload.fileUrl ?? null,
    fileName: payload.fileName ?? null,
  };
}

export function revokeOptimisticBlobUrl(message) {
  const url = message?._localBlobUrl;
  if (!url) return;
  try {
    URL.revokeObjectURL(url);
  } catch {
    /* ignore */
  }
}
